export const LightType = {
    spotLight: "spotLight",
    pointLight: "pointLight",
    directionalLight: "directionalLight",
} as const;
export type LightType = (typeof LightType)[keyof typeof LightType];
